<app-card-table [info]="info" (refresh)="getWalletInfo()"></app-card-table>